export default class AboutMe {
  id: string;
  currentAppearance: string;
}
